import Client from '../../../../Client';
import Categories from './Categories.json';
import Offers from './Offers-mock.json';

export default class MobileOffersMockNamespace {
  dataSet = Offers.data.records;

  categoriesDataSet = Categories.data.records;

  /** *
   * @param {Client} Client - instance of client
   * @param {MockFramework} Framework - instance of framework
   */
  constructor(Client, Framework) {
    this.client = Client;
    this.framework = Framework;
  }

  translateEntities = (offer) => {
    const { category_id, section_id } = offer;

    offer.category = this.categoriesDataSet.find(
      ({ id }) => id === parseInt(category_id, 10)
    );

    return offer;
  };

  getEndpoints() {
    return {
      'mobile/offers': (
        payload,
        headers,
        method,
        transmitType,
        isLoggedIn,
        userPermissions,
        error
      ) => {
        const permittedErrors = ['not_logged_in', 'no_permission'];
        const filters = {
          id: {
            field: 'id',
            expression: 'eq'
          },
          name: {
            field: 'name',
            expression: 'like'
          }
        };
        return this.framework.defaultSearchMock(
          payload,
          this.dataSet,
          filters,
          permittedErrors,
          error
        );
      },
      'mobile/offers/categories': () => {
        const dashboard = {
          records: this.categoriesDataSet
        };
        return {
          code: 200,
          data: { ...dashboard }
        };
      },
      'mobile/offers/delete': (
        payload,
        headers,
        method,
        transmitType,
        isLoggedIn,
        templatePermissions,
        error
      ) => {
        const permittedErrors = [
          'not_logged_in',
          'no_permission',
          'provide_id',
          'no_records',
          'delete_no_record'
        ];
        return this.framework.defaultDeleteMock(
          this.dataSet,
          payload.id,
          'id',
          permittedErrors,
          error,
          'delete_no_record',
          isLoggedIn
        );
      },
      'mobile/offers/create': (
        payload,
        headers,
        method,
        transmitType,
        isLoggedIn,
        userPermissions,
        error
      ) => {
        const permittedErrors = [
          'not_logged_in',
          'system_error',
          'no_permission',
          'provide_building_id'
        ];

        if (error !== false && permittedErrors.includes(error)) {
          return this.framework.createErrorResponse(error);
        }
        if (!isLoggedIn) {
          return this.framework.createErrorResponse('not_logged_in');
        }

        const {
          building_id,
          category_id,
          description,
          end_date_time,
          featured,
          location,
          promo_code,
          publish_date_time,
          retailer,
          start_date_time,
          terms_and_conditions,
          title
        } = payload;

        const entity = {
          id: this.dataSet.length + 1,
          building_id,
          category_id,
          description,
          end_date_time,
          featured,
          location,
          promo_code,
          publish_date_time,
          retailer,
          start_date_time,
          terms_and_conditions,
          title,
          images: [
            {
              id: '573fe8a9-8b8d-4daa-b70a-0c51477e9225',
              entity_type: 'offer',
              user_id: 1,
              uri: 'http://placeimg.com/640/480/architecture',
              filesize: 0,
              type: '',
              verified: false
            }
          ],
          created: new Date().toISOString(),
          modified: new Date().toISOString()
        };
        const translatedEntity = this.translateEntities(entity);
        this.dataSet.push(translatedEntity);
        return {
          code: 200,
          data: { offer: entity }
        };
      },
      'mobile/offers/update': (
        payload,
        headers,
        method,
        transmitType,
        isLoggedIn,
        userPermissions,
        error
      ) => {
        const permittedErrors = [
          'not_logged_in',
          'no_permission',
          'provide_id',
          'update_no_permission',
          'provide_offer_id'
        ];

        if (error !== false && permittedErrors.includes(error)) {
          return this.framework.createErrorResponse(error);
        }
        if (!isLoggedIn) {
          return this.framework.createErrorResponse('not_logged_in');
        }

        try {
          const offer = this.framework.updateRecord(
            this.dataSet,
            payload.id,
            'id',
            this.translateEntities(payload)
          );

          return {
            code: 200,
            data: { offer }
          };
        } catch (e) {
          return this.framework.createErrorResponse('no_permission');
        }
      },
      'mobile/offers/unarchive': (
        payload,
        headers,
        method,
        transmitType,
        isLoggedIn,
        userPermissions,
        error
      ) => {
        const permittedErrors = [
          'not_logged_in',
          'system_error',
          'no_permission',
          'provide_id'
        ];

        if (error !== false && permittedErrors.includes(error)) {
          return this.framework.createErrorResponse(error);
        }

        if (!isLoggedIn) {
          return this.framework.createErrorResponse('not_logged_in');
        }

        try {
          const archived = false;
          this.framework.updateRecord(this.dataSet, payload.id, 'id', {
            archived
          });
          return {
            code: 200,
            data: { archived }
          };
        } catch (e) {
          return this.framework.createErrorResponse('no_permission');
        }
      },

      'mobile/offers/archive': (
        payload,
        headers,
        method,
        transmitType,
        isLoggedIn,
        userPermissions,
        error
      ) => {
        const permittedErrors = [
          'not_logged_in',
          'system_error',
          'no_permission',
          'provide_id'
        ];

        if (error !== false && permittedErrors.includes(error)) {
          return this.framework.createErrorResponse(error);
        }

        if (!isLoggedIn) {
          return this.framework.createErrorResponse('not_logged_in');
        }

        try {
          const archived = true;
          this.framework.updateRecord(this.dataSet, payload.id, 'id', {
            archived
          });
          return {
            code: 200,
            data: { archived }
          };
        } catch (e) {
          return this.framework.createErrorResponse('no_permission');
        }
      }
    };
  }
}
